module.exports = __webpack_public_path__ + "img/pulse-iot-center.1b8091bf.jpg";